import Api from './api';

const SolicitacaoService = {
    cadastro: async (params) => {
        const response = await Api.post('/solicitacao/cadastrar', params)
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/solicitacao/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/solicitacao/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    solicEdit: async (id) => {
        const response = await Api.get(`/solicitacao/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/solicitacao/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    verSolicitacao: async (id) => {
        const response = await Api.get(`/solicitacao/solicitacao/${id}`)
        return response
    },
    novoComponente: async (id, params) => {
        const response = await Api.post(`/solicitacao/solicitacao/${id}/componentes`, params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    delComponente: async (id, data) => {
        const response = await Api({
            method: 'delete',
            url: `/solicitacao/delcomp/${id}`,
            data: data,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    previewNumero: async () => {
        const response = await Api({
            method: 'get',
            url: '/solicitacao/preview-numero',
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    confirmaSolicitacao: async (id, formData) => {
        const response = await Api.post(
            `/solicitacao/solicitacao/${id}/memorando`,
            formData,
            {
                headers: {
                    'x-access-token': localStorage.getItem('token'),
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    },
    buscarSolicitacao: (params) => {
        const response = Api.get(`/solicitacao/buscar?${params}`)
        return response
    },
}

export default SolicitacaoService;
